/**
 * マーカー画像の自然サイズキャッシュ
 * 画像URLをキーとして自然サイズを保持し、全Markerインスタンスで共有する
 */
export const iconNaturalSizeCache = new Map<string, { w: number; h: number }>()

/**
 * 読み込み中の自然サイズ取得
 * 同一URLの preload 完了前重複を防ぐため共有する
 */
const iconNaturalSizePending = new Set<string>()

/**
 * 画像URLの自然サイズをキャッシュに事前登録する
 * ブラウザのHTTPキャッシュにも乗るため、描画時の画像ロードも高速化される
 * @param url - アイコン画像のURL
 */
export function preloadAndCacheIconNaturalSize(url: string): void {
  if (!url) {
    return
  }

  if (iconNaturalSizeCache.has(url) || iconNaturalSizePending.has(url)) {
    return
  }

  iconNaturalSizePending.add(url)

  const img = new Image()

  img.onload = () => {
    const size = {
      w: img.naturalWidth,
      h: img.naturalHeight
    }

    iconNaturalSizeCache.set(url, size)
    iconNaturalSizePending.delete(url)
  }

  img.onerror = () => {
    iconNaturalSizePending.delete(url)
  }

  // プリロード実行
  img.src = url
}
